import { render, staticRenderFns } from "./WealthHighscoreComponent.vue?vue&type=template&id=555ec7fb&"
import script from "./WealthHighscoreComponent.vue?vue&type=script&lang=ts&"
export * from "./WealthHighscoreComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WealthHighscoreComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports